import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import GenericViewsToolbar from "../components/GenericViewsToolbar/GenericViewsToolbar";
import { getConfigVariable } from "../config/config";
import { hasModule } from "../utils/utils";
import AppNewLogic from "../controllers/App/AppNewLogic";
import { controllerQueries } from "../controllers/utils/utils";

const queries = (args = {}) => {
    if (args && args.id) {
        return [
            {
                resource: "fact_custom",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    modulePrefix: args.modulePrefix,
                    importId: args.importId,
                    locale: args.locale,
                    id: args.id,
                    filter: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    sort: args.sort
                        ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                        : undefined,
                    page: parseInt(args.page, 10) || 0,
                    pageSize: parseInt(
                        args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                    ),
                },
                body: `__typename, items{ ...fact_custom}, headerItems, hasMore, total, totalizers, filters(projectId:$projectId,fiscalYear:$fiscalYear,importId:$importId,modulePrefix:$modulePrefix,reportId:$id,locale:$locale){ prop, name, type, list, disableOperators, mandatory }`,
                downloadable: false,
                isDatagridReq: true,
            },
            {
                resource: `fact_custom_export`,
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    modulePrefix: args.modulePrefix,
                    importId: args.importId,
                    locale: args.locale,
                    id: args.id,
                    filter: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    sort: args.sort
                        ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                        : undefined,
                    page: parseInt(args.page, 10) || 0,
                },
                body: `report`,
                downloadable: true,
                downloadOnly: true,
                xlsxTranslation: "fact_custom",
            },
            {
                resource: `fact_custom_report_name`,
                args: {
                    locale: args.locale,
                    id: args.id,
                },
                body: `reportName`,
            },
            {
                resource: "data_files_types_present",
                args: {
                    projectId: args.projectId,
                },
                body: "hasSource, hasLegal",
            },
        ];
    }
    return [
        {
            resource: "custom_reports_by_project",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                modulePrefix: args.modulePrefix,
                importId: args.importId,
                locale: args.locale,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: `__typename, items{ ...custom_reports_by_project }, hasMore, total, totalizers, filters(projectId:$projectId,fiscalYear:$fiscalYear,importId:$importId,modulePrefix:$modulePrefix){ prop, name, type, list, disableOperators, mandatory }`,
            downloadable: true,
        },
        {
            resource: "data_files_types_present",
            args: {
                projectId: args.projectId,
            },
            body: "hasSource, hasLegal",
        },
    ];
};

const queriesWrapper = (args = {}) => queries({ ...args });

const CustomReportController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hasHeroBanner: true };
    const Controller = hasModule(modules, "new_navigation") ? AppNewLogic : App;
    return <Controller {...modifiedProps} />;
};

CustomReportController.queries = (args, userModulesByProject) => {
    return controllerQueries(args, userModulesByProject);
};

const CustomReport = (
    path,
    navigation,
    exact,
    title,
    staticParams = {},
    useNewController = false,
) => {
    const ControllerWrapper = (props) =>
        CustomReportController(props, useNewController, { ...staticParams });
    ControllerWrapper.queries = CustomReportController.queries;
    return {
        path,
        navigation,
        component: ControllerWrapper,
        queries: (args = {}) => queriesWrapper({ ...staticParams, ...args }),
        exact,
        title: [title, "query(2).reportName"],
        navByImportId: true,
        components: [
            {
                component: DataGrid,
                props: {
                    id: "results",
                    card: rows.CellCard,
                    items: "query(0).list",
                    header: "query(0).header",
                    footer: "query(0).footer",
                    metadata: "query(0).metadata",
                    page: "param(page)",
                    status: "status(0)",
                    sort: "param(sort)",
                    pageSize: "param(pageSize)",
                    pageDefault: 10,
                    filter: "param(filter)",
                    availableFilters: "query(0).filters",
                    wrapper: "wrapper",
                    total: "query(0).metadata.total",
                    totalizers: "query(0).totalizers",
                    projectModules: "query(1)",
                    toolbar: GenericViewsToolbar,
                    toolbarProps: {
                        data: "query(0).list",
                    },
                },
            },
        ],
    };
};

export default CustomReport;
